import Vue from 'vue'

const store = Vue.observable({
  menuActive         : false,
  searchActive       : false,
  notificationsActive: false,
  closeAnnouncement  : false,
  customerCountry    : 'NZ'
})

const actions = {
  openMenu () {
    store.menuActive = true
  },

  toggleMenu () {
    if (store.menuActive) {
      this.closeAll()
    } else {
      this.closeAll()
      store.menuActive = true
    }
  },

  toggleSearch () {
    store.searchActive = !store.searchActive
  },

  toggleNotifications () {
    store.notificationsActive = !store.notificationsActive
  },

  closeAll () {
    store.menuActive = false
    store.searchActive = false
    store.notificationsActive = false
    window.PSTheme.Vue.Header.secondMenuIdx = null
    window.PSTheme.Vue.Header.thirdMenuIdx = null
  }
}

Vue.prototype.$store = store
Vue.prototype.$actions = actions
